const track = (event, properties, options, fn) =>
  typeof window !== 'undefined' &&
  window.analytics &&
  window.analytics.track &&
  window.analytics.track(event, properties, options, fn);
export default track;
